const state = {
	apiVersion : undefined
};

const getters = {
	getApiVersion(state){
		return state.apiVersion
	}
};

const mutations = {
	SETAPIVERSION(state, object){
		state.apiVersion = object
	}
};

const actions = {
	setApiVersion({commit}, object){
		commit("SETAPIVERSION", object)
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
